
































































import { Component, Vue, Watch } from 'vue-property-decorator';
import GlobalMixins from '@/mixins';
import AppNav from '@/components/AppNav.vue'
import { IStatement } from './interfaces';
import { Route } from 'vue-router';

@Component({
	components: {
		AppNav
	}
})
export default class App extends GlobalMixins {
	resizeId: any = null
	preventScrolling: boolean = false
	animateOnLoad: boolean = false
	privacyModalOpen: boolean = false

	get routeKey(): string {
		return this.$route.name === 'results' || this.$route.name === 'choices-overview' ? 'results' : this.$route.path
	}
	get contentAnimation() {
		if (this.animateOnLoad) {
			if (this.config.settings.showAd) {
				return `content-slide-with-ad-${this.$store.getters.direction}`
			} else {
				return `content-slide-${this.$store.getters.direction}`
			}
		} else {
			return 'fade'
		}
	}

	@Watch('$route')
	onRouteChange() {
		this.setDocumentTitle()

		if (this.$route.name === 'start' && this.$store.getters.showPrivacyStatement) this.closePrivacy()
	}

	calculateHeight(): void {
		document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
	}
	closePrivacy(): void {
		this.$store.dispatch('seenPrivacyStatement')
	}
	closePrivacyModal(e: any): void {
		if (e.target.classList.contains('modal__wrapper')) {
			this.privacyModalOpen = false
		}
	}

	created() {
		this.calculateHeight

		const app = this

		window.addEventListener('resize', () => {
			clearTimeout(app.resizeId);
			app.resizeId = setTimeout(app.calculateHeight, 500);
		})
		window.addEventListener('popstate', () => {
			this.setDocumentTitle()
		})

		document.addEventListener('keyup', (e: any) => {
			if (e.code === 'Escape') this.privacyModalOpen = false;
			if (e.code === 'Tab' && this.privacyModalOpen) 
			{
				e.preventDefault();
				if (!(this.$refs.modalWrapper as HTMLElement).contains(document.activeElement)) (this.$refs.modalClose as HTMLElement).focus();
			}
		})

		this.setDocumentTitle()

		if (this.config.settings.showAd) {
			document.body.classList.add('with-ad')
		}
	}
	mounted() {
		setTimeout(() => {
			this.animateOnLoad = true
		}, 150)
	}
}
